// extracted by mini-css-extract-plugin
export default {"sam-entity-search-root":"SamEntitySearch_sam-entity-search-root__SJf7B","input-wrapper":"SamEntitySearch_input-wrapper__6h7AP"};